
import React from 'react';
import AuthLayout from '@/components/auth/AuthLayout';
import LoginForm from '@/components/auth/LoginForm';
import { Navigate, useLocation } from 'react-router-dom';
import { useUser } from '@/contexts/UserContext';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

export default function Login() {
  const { isAuthenticated, isLoading } = useUser();
  const location = useLocation();
  const registrationSuccess = location.state?.registrationSuccess;
  const passwordResetSuccess = location.state?.passwordResetSuccess;
  const email = location.state?.email;

  // Show loading spinner while auth state is being determined
  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-2"></div>
          <p className="text-sm text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  // Redirect authenticated users to home
  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <AuthLayout 
      title="Welcome Back" 
      description="Sign in to your account to access your meal plans"
    >
      {registrationSuccess && (
        <Card className="mb-6">
          <CardHeader className="text-center pb-2">
            <CardTitle className="text-lg">Check your email</CardTitle>
          </CardHeader>
          <CardContent className="text-center space-y-2">
            <p className="text-foreground">
              We've sent a confirmation link to <strong>{email}</strong>
            </p>
            <CardDescription>
              Click the link in your email to verify your account, then return here to sign in.
              Don't forget to check your spam folder!
            </CardDescription>
          </CardContent>
        </Card>
      )}
      {passwordResetSuccess && (
        <Card className="mb-6">
          <CardHeader className="text-center pb-2">
            <CardTitle className="text-lg">Password Updated</CardTitle>
          </CardHeader>
          <CardContent className="text-center">
            <p className="text-foreground">
              Your password has been successfully updated. Please sign in with your new password.
            </p>
          </CardContent>
        </Card>
      )}
      <LoginForm />
    </AuthLayout>
  );
}
